import { render, staticRenderFns } from "./TicketChart.vue?vue&type=template&id=40fa9703"
import script from "./TicketChart.vue?vue&type=script&lang=js"
export * from "./TicketChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports